import ReactEcharts from "echarts-for-react";

export function SimpleLineChart({ style, dados = [], paletaDeCores = [] }) {
  
  const option = {
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      show: window.innerWidth <= 600 ? false : true,
      icon: 'circle',
      bottom: 0,
    },
    toolbox: {
      show: true,
      feature: {
        dataZoom: {
          yAxisIndex: 'none'
        },
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: window.innerWidth <= 600 ? '3%' : '8%',
      containLabel: true
    },
    xAxis: {
      data: dados.datas,
      type: 'category',
      boundaryGap: false,
    },
    yAxis: {
      type: 'value'
    },

    series:[
      {
        name: "Apoiado(a)",
        type: 'line',
        data: dados.sentimento1,
      },
      {
        name: "Reconhecido(a)",
        type: 'line',
        data: dados.sentimento2,
      },
      {
        name: "Adoecido(a)",
        type: 'line',
        data: dados.sentimento3,
      },
      {
        name: "Raiva",
        type: 'line',
        data: dados.sentimento4,
      },
      {
        name: "Medo",
        type: 'line',
        data: dados.sentimento5,
      },
      {
        name: "Alegre",
        type: 'line',
        data: dados.sentimento6,
      },
      {
        name: "Triste",
        type: 'line',
        data: dados.sentimento7,
      },
    ]
    
      
  };

  return <ReactEcharts option={option} style={style} />;
}
